<template>
  <div>
    <CRow>
      <CCol sm=12>
        <CRow>
          <CCol sm="9">
            <ul class="nav nav-pills mb-3" role="tablist">
              <li class="nav-item"  @click.prevent="() => {current_Tab = 'urgent_action_items'}" style="cursor:pointer">
                <a class="nav-link" :class="{'active' : current_Tab === 'urgent_action_items' }"  role="tab" aria-controls="pills-home"
                   aria-selected="true">Pending
                  <span class="badge badge-light">{{ all_items.total - status_count.completed_items_count}}</span>
                </a>
              </li>
              <li class="nav-item" @click.prevent="() => {current_Tab = 'completed'}" style="cursor:pointer">
                <a class="nav-link"  :class="{'active' : current_Tab === 'completed' }" role="tab" aria-controls="pills-contact" aria-selected="false">Completed
                  <span class="badge badge-light">{{status_count.completed_items_count}}</span>
                </a>
              </li>
              <li class="nav-item" @click.prevent="() => {current_Tab = 'all_items'}" style="cursor:pointer">
                <a class="nav-link"  :class="{'active' : current_Tab === 'all_items' }" role="tab" aria-controls="pills-contact" aria-selected="false">All
                  <span class="badge badge-light">{{all_items.total}}</span>
                </a>
              </li>
            </ul>
          </CCol>
          <CCol sm="3">
              <search
                  v-model="params.search"
                  float='right'
                  :clickHandler="searchOrders"
                  placeholder="Type Order No"
              />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            <div class="tab-content" >
              <div class="tab-pane fade" :class="{'show active': current_Tab === 'all_items'}" role="tabpanel" aria-labelledby="pills-contact-tab" v-if="current_Tab === 'all_items'">
                <div>
                  <div class="mt-2">
                    <h3 class="my-2">All Orders</h3>
                    <table class="urgent_action_items">
                      <tr>
                        <th style="vertical-align: top" ><span><b-icon-sort-down /></span> Order No</th>
                        <th style="vertical-align: top; white-space: nowrap" ><span><b-icon-sort-down /></span> Customer</th>
                        <th v-if="$can('order-listing-shipping-address-column')" style="vertical-align: top" ><span><b-icon-sort-down /></span> Shipping Address</th>
                        <th style="vertical-align: top"  v-if="$can('order-listing-merchant-column')"><span><b-icon-sort-down /></span> Merchant</th>
                        <th style="vertical-align: top"  v-if="$can('order-listing-factory-column')"><span><b-icon-sort-down /></span> Factory</th>
                        <th style="vertical-align: top; white-space: nowrap" ><span><b-icon-sort-down /></span> Reference</th>
                        <th style="vertical-align: top; white-space: nowrap" ><span><b-icon-sort-down /></span> Merchant</th>
                        <th style="vertical-align: top" ><span><b-icon-sort-down /></span> No of<br/>SKUs</th>
                        <th style="vertical-align: top" ><span><b-icon-sort-down /></span> Order Quantity</th>
                        <th style="vertical-align: top; white-space: nowrap" ><span><b-icon-sort-down /></span> Status</th>
                        <th style="vertical-align: top; white-space: nowrap" ><span><b-icon-sort-down /></span> Date</th>
                        <th style="vertical-align: top" ><span><b-icon-sort-down /></span> Days Since<br/>Action</th>
                        <th style="vertical-align: top" ><span><b-icon-sort-down /></span> Days Since<br/>Ordered</th>
                        <th style="vertical-align: top" >Quick<br />Action</th>
                      </tr>
                      <template  v-if="isLoading || all_items.data.length === 0">
                        <td colspan="7">No Data exist</td>
                      </template>
                      <template v-else v-for="(factory_await_item,index) in all_items.data">
                        <tr :key="index">
                          <td>
                            {{factory_await_item.hasOwnProperty('order')? factory_await_item.order.order_no:''}}
                          </td>
                          <td>
                            {{factory_await_item.hasOwnProperty('order')?factory_await_item.order.customer_name:''  | capitalize}}
                          </td>
                          <td v-if="$can('order-listing-shipping-address-column')">
                            {{factory_await_item.hasOwnProperty('order')?factory_await_item.order.shipping_address:null | shippingAddress}}
                          </td>
                          <td v-if="$can('order-listing-merchant-column')"> {{factory_await_item.hasOwnProperty('order')?factory_await_item.order.company_name:'' | capitalize}}</td>
                          <td v-if="$can('order-listing-factory-column')" title="Factory 1, Factory 2, Factory 3">{{factory_await_item.factory_name | capitalize}}...</td>
                          <td>
                            {{factory_await_item.order.customer_reference_no ? factory_await_item.order.customer_reference_no : 'N/A'}}
                          </td>
                          <td>
                            {{factory_await_item.order.company_name}}
                          </td>
                          <td>
                            {{factory_await_item.items_count}}
                          </td>
                          <td>
                            {{ calculateOrderQuantity(factory_await_item) }}
                          </td>
                          <td>
                            <span class="factory_status" :class="factory_await_item.status">
                              <template v-if="factory_await_item.status === 'submitted_for_factory_review'">
                                Submitted For Merchant Review
                              </template>
                              <template v-else>
                                {{factory_await_item.status | status}}
                              </template>
                            </span>
                          </td>
                          <td>
                            {{factory_await_item.status_updated_at | date}}
                          </td>
                          <td>
                            {{factory_await_item.status_updated_at | ago}}
                          </td>
                          <td>
                            {{factory_await_item.status_updated_at | ago}}
                          </td>
                          <td v-if="false">
                            <a @click="openAWSFileFromOrder(factory_await_item.order)" class="btn btn-secondary mx-2">PDF</a>
                            <router-link  :to="`order/${factory_await_item.order.id}/detail`" class="btn btn-secondary mx-2">Details</router-link>
                          </td>
                          <td>
                            <CDropdown
                                class="c-header-nav-items"
                                placement="bottom-end"
                                add-menu-classes="pt-0"
                            >
                              <template #toggler>
                                <a class="btn btn-secondary mx-2">
                                  <b-icon-three-dots />
                                </a>
                              </template>

                              <CDropdownItem @click="openAWSFileFromOrder(factory_await_item.order)">
                                <CIcon name="cil-file" /> &nbsp; Download PDF
                              </CDropdownItem>
                              <CDropdownDivider/>
                              <CDropdownItem @click.prevent="$router.push({path:`order/${factory_await_item.order.id}/detail`})">
                                <CIcon name="cil-list" /> &nbsp; Order Details
                              </CDropdownItem>
                              <CDropdownDivider/>
                              <!-- Tech Pack button hide for old orders because of different old order data structure -->
                              <template v-if="app_environment !== 'production'">
                                <CDropdownItem  :href="`/order/${factory_await_item.order.id}/condensend-pdf`" target="_blank">
                                  <CIcon name="cil-file" /> &nbsp; Tech Pack pdf
                                </CDropdownItem>
                              </template>
                              <template v-else>
                                <CDropdownItem  v-if="factory_await_item.order.id > 115" :href="`/order/${factory_await_item.order.id}/condensend-pdf`" target="_blank">
                                  <CIcon name="cil-file" /> &nbsp; Tech Pack pdf
                                </CDropdownItem>
                              </template>

                              <CDropdownDivider/>
                              <CDropdownItem @click.prevent="null">
                                <CIcon name="cil-layers" /> &nbsp; Download Assets
                              </CDropdownItem>

                              <template v-if="$can('delete-order')">
                                <CDropdownDivider/>
                                <CDropdownItem @click.prevent="deleteOrder(factory_await_item.order.id)">
                                  <CIcon name="cil-x-circle" /> &nbsp; Delete Order
                                </CDropdownItem>
                              </template>
                            </CDropdown>
                          </td>
                        </tr>
                      </template>

                    </table>
                    <div class="my-5 d-flex gap-1 justify-content-center align-items-center">
                      <b-pagination :key="Math.random()"
                                    class="mb-0"
                                    v-model="all_items.current_page"
                                    :total-rows="all_items.total"
                                    :per-page="all_items.per_page"
                                    aria-controls="itemList"
                                    align="center"
                                    @change="handlePagination($event, 'all_items')"
                                    v-if="all_items.total > 0"
                      ></b-pagination>

                      <div style="width: 230px">
                        <CSelect
                            class="mb-0 w-100 mx-1"
                            value="Medium"
                            :options="['10','20','30']"
                            custom
                            prepend="Orders per page"
                        />
                      </div>
                  </div>
                  </div>
                </div>
                </div>
              </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { http } from "@/config/httpCommon"
import moment from 'moment'
import {CustimooOrderFlowStatuses, getPageModal} from '@/helpers/Helpers'

export default {
  name: 'Dashboard',
  components: {
  },
  computed:{
    company_name(){
      let user = JSON.parse(localStorage.getItem('user'))
      let company = ''
      if (user && user.store){
        company = user.store
      }
      return company
    }
  },
  watch:{
    current_Tab :
        {
          handler: function (val, oldVal) {
            this.getDashboardData(1,this.current_Tab); // call it in the context of your component object
          },
        }
  },
  data () {
    return {
      isLoading: false,
      storage_url:process.env.VUE_APP_FILE_URL,
      params:{
        search:"",
      },
      current_Tab:"all_items",
      selected: 'Month',
      status_count:{
        completed_items_count:0,
        created_items_count:0,
        production_items_count:0,
        shipped_items_count:0
      },
      urgent_action_items:{
        data:[]
      },
      customer_await_items:{
        data:[]
      },
      pending_items:{
        data:[]
      },
      completed_items:{
        data:[]
      },
      all_items:{
      },
      orders: [],
      role:{},
    }
  },
  filters: {
    date: function (date) {
      return moment(date).format('DD-MM-YY');
    },
    ago: function(date){
      return moment(date).fromNow(true)
    },
    capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
    },
    status: function(value){
      if (value) {
        return CustimooOrderFlowStatuses[value];
      }
    },
    shippingAddress : function (shipping_address) {
      if(!shipping_address){
        return '';
      }else{
        return  `${shipping_address.address1 || ''} ${shipping_address.address2 || ''} ${shipping_address.city || ''}
        ${shipping_address.zip_code || ''} ${shipping_address.country || ''}`
      }
    }
  },
  async created(){
    this.isLoading = true;
    this.role = localStorage.getItem('role')?JSON.parse(localStorage.getItem('role')): null;
  },
  async mounted(){
    await this.getDashboardData(1,this.current_Tab);
  },
  methods: {
    async deleteOrder(orderID){
      let confirmDelete = confirm('Are you sure that you want to delete this order?');

      if(confirmDelete) {
        try {
          this.isLoading = true;
          this.$store.commit('set', ['showLoader', true]);
          await http.delete(`order/delete/${orderID}`).then(async response => {
            if (response.data.success && response.data.status_code === 200) {
              this.showToast(response.data.message, 'SUCCESS');
              await this.getDashboardData(this.all_items.page ? this.all_items.page : 1, this.current_Tab);
              this.isLoading = false;
              this.$store.commit('set', ['showLoader', false]);
            } else {
              this.isLoading = false;
              this.$store.commit('set', ['showLoader', false]);
            }
          });
        } catch (e) {
          console.log(e);
          this.isLoading = false
        }
      }
    },
    async getDashboardData(page=null,items_for=null){
      try{
        this.isLoading = true;
          await http.get(`dashboard?items_for=${items_for}${page?`&page=${page}`:''}${this.params.search?'&search='+ this.params.search:''}`).then(response => {
            if(response.data.success && response.data.status_code === 200){
                if(page === 1 && items_for=='all_items'){
                  this.status_count.completed_items_count  = response.data.result.completed_items_count
                  this.status_count.created_items_count  = response.data.result.created_items_count
                  this.status_count.production_items_count  = response.data.result.production_items_count
                  this.status_count.shipped_items_count  = response.data.result.shipped_items_count
                }
                this[this.current_Tab] = response.data.result.items
                this.isLoading = false;
              }else{
                this.isLoading = false;
              }
          });
      }
      catch(e){
        console.log(e);
        this.isLoading = false
      }
  },
  async handlePagination(page= '', items_for){
      try{
          this.isLoading = true;
          if(this.current_Tab !== 'all_items'){
              await http.get(`dashboard/items?items_for=${items_for}${page?`&page=${page}`:''}&search=${this.params.search}`).then(response => {
                if(response.data.success){
                  console.log(response);
                  this[items_for] = response.data.result.items
                  // this.orders = response.data.result.orders;
                  this.isLoading = false;
                }else{
                  this.isLoading = false
                }

              });
          }
          else{
                this.getDashboardData(page,items_for);
          }

      }
      catch(e){
        console.log(e);
        this.isLoading = false
      }

  },
  async searchOrders(search){
    this.params.search = search;
    this.handlePagination(1,this.current_Tab)
  },
    uploadDesign(user){
      console.log(user);
    },
    message(user){
      console.log(user);
    },
    calculateOrderQuantity(order) {
      const roster_quantity = order.factory_products?.flatMap(product =>
          product.product_roster_detail.map(detail => parseInt(detail.quantity, 10))
      ).reduce((acc, cur) => acc + cur, 0);
      return roster_quantity;
    },
    async openAWSFileFromOrder(order){
      try{      
        let order_id = order.id

        // Fetch the URL from the Laravel API
        this.$store.commit('set', ['showLoader', true]);
        const response = await http.get(`designfile/order/${order_id}`);
        this.$store.commit('set', ['showLoader', false]);
        const url = response.data.result.url;
        if(url){
          window.open(`${url}`, '_blank');
        }
      } catch (error) {
        console.error('Error fetching the PDF URL:', error);
      }
    },
  },
}
</script>
<style lang="scss" scoped>
table.urgent_action_items{
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

table.urgent_action_items td, table.urgent_action_items th {
  border: 1px solid #ddd;
  padding: 8px;
}

table.urgent_action_items tr:nth-child(even){background-color: #f2f2f2;}

table.urgent_action_items tr:hover {background-color: #ddd;}

table.urgent_action_items th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #fa1313;
  color: white;
}

table.pending_items{
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

table.pending_items td, table.pending_items th {
  border: 1px solid #ddd;
  padding: 8px;
}

table.pending_items tr:nth-child(even){background-color: #f2f2f2;}

table.pending_items tr:hover {background-color: #ddd;}

table.pending_items th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #424242;
  color: white;
}
table.customer_await_items{
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

table.customer_await_items td, table.customer_await_items th {
  border: 1px solid #ddd;
  padding: 8px;
}

table.customer_await_items tr:nth-child(even){background-color: #f2f2f2;}

table.customer_await_items tr:hover {background-color: #ddd;}

table.customer_await_items th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #04AA6D;
  color: white;
}

table.all_items{
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

table.all_items td, table.all_items th {
  border: 1px solid #ddd;
  padding: 8px;
}

table.all_items tr:nth-child(even){background-color: #f2f2f2;}

table.all_items tr:hover {background-color: #ddd;}

table.all_items th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #200370;
  color: white;
}
</style>
